/**
 * Métricas Pareto 80/20 — alineadas con filas del PyG analítico por marca.
 *
 * Venta: epígrafe 1 + PROYECCIÓN VENTAS + PEDIDOS VENTA
 * Resultado: (Venta + proy. venta + ped. venta) − (Compra + proy. compra + ped. compra)
 */

export const paretoVentaTotal = (row) => {
  const ventaContable = Number(row?.venta) || 0;
  const proyeccionVentas = Number(row?.proyeccionVentas) || 0;
  const pedidosVenta = Number(row?.pedidosVenta) || 0;
  const facturasBorradorVenta = Number(row?.facturasBorradorVenta) || 0;
  return ventaContable + proyeccionVentas + pedidosVenta + facturasBorradorVenta;
};

export const paretoResultadoFinal = (row) => Number(row?.resultado) || 0;

export const paretoMetricValor = (row, metric) => {
  switch (metric) {
    case "venta":
      return paretoVentaTotal(row);
    case "resultado":
      return paretoResultadoFinal(row);
    default:
      return 0;
  }
};

export const PARETO_METRIC_LABELS = {
  venta: "Venta total",
  resultado: "Resultado",
};

export const buildParetoSeries = (rows, metric = "venta", maxChartPoints) => {
  const items = rows
    .map((r) => ({
      marca: r.marca,
      prioridad: r.prioridad,
      ventaContable: Number(r?.venta) || 0,
      proyeccionVentas: Number(r?.proyeccionVentas) || 0,
      pedidosVenta: Number(r?.pedidosVenta) || 0,
      resultado: Number(r?.resultado) || 0,
      valor: paretoMetricValor(r, metric),
    }))
    .filter((x) => x.valor > 0)
    .sort((a, b) => b.valor - a.valor);

  const total = items.reduce((s, x) => s + x.valor, 0);
  if (!total || !items.length) {
    return {
      points: [],
      chartPoints: [],
      total: 0,
      marcasHasta80: 0,
      pctCatalogo80: 0,
      totalMarcas: 0,
      truncated: false,
      metric,
    };
  }

  let acum = 0;
  const points = items.map((item, index) => {
    acum += item.valor;
    return {
      ...item,
      rank: index + 1,
      pctParte: (item.valor / total) * 100,
      pctAcumulado: (acum / total) * 100,
      dentro80: false,
    };
  });

  const idx80 = points.findIndex((p) => p.pctAcumulado >= 80);
  const marcasHasta80 = idx80 >= 0 ? idx80 + 1 : points.length;
  points.forEach((p, i) => {
    p.dentro80 = i < marcasHasta80;
  });

  const limit =
    maxChartPoints == null || maxChartPoints <= 0 ? points.length : Math.max(1, maxChartPoints);
  const chartPoints = points.slice(0, limit);

  return {
    points,
    chartPoints,
    total,
    marcasHasta80,
    pctCatalogo80: (marcasHasta80 / points.length) * 100,
    totalMarcas: points.length,
    truncated: points.length > chartPoints.length,
    metric,
  };
};
